<div>{{ 'ForceUnpairContent' | translate: { patientName: patientName() } }}</div>
